import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import BannerComponent from "../components/multi_cotizacion/banner.component";
import DescriptionComponent from "../components/multi_cotizacion/description.component";
import CotizacionVehiculosComponent from "../components/multi_cotizacion/cotizacion-vehiculos.component";
import VehiculosComponent from "../components/multi_cotizacion/vehiculos.component";
import {
  multicotizador,
  vehiclesSimulator,
} from "../components/conexion/vehicles.conexion";

const CotizadorPlaceholder = () => (
  <div
    id="cotizador"
    className="cotizacion-multiple-component placeholder"
    style={{
      minHeight: "900px",
      backgroundColor: "#e0e0e0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "20px",
      margin: "40px 7%",
      background: "linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)",
      backgroundSize: "200% 100%",
      animation: "pulse-skeleton 1.5s ease-in-out infinite"
    }}
  >
    <div style={{ color: "#999", fontFamily: "sans-serif" }}>
      Cargando cotizador...
    </div>
  </div>
);

const MultiCotizacionPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [vehiculosData, setVehiculosData]: any = useState([]);
  const [vehiculosSelected, setVehiculosSelected]: any = useState(null);
  const [multicotizadorData, setMulticotizadorData]: any = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      vehiclesSimulator(),
      multicotizador()
    ]).then(([vehiclesRes, multicotizadorRes]) => {
      let data: any = vehiclesRes?.data?.data;
      setVehiculosData(data);
      setVehiculosSelected(data[0]);
      setMulticotizadorData(multicotizadorRes?.data?.data);
      setIsLoading(false);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="somos"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Multicotización Hyundai Colombia - Compara y Encuentra tu Mejor Opción
        </h1>

        <div className="home-page-mascara"></div>
        <BannerComponent multicotizadorData={multicotizadorData} />
        <DescriptionComponent multicotizadorData={multicotizadorData} />

        <div className="cotizacion-multiple-component" id="cotizacion">
          {isLoading ? (
            <CotizadorPlaceholder />
          ) : (
            <>
              <VehiculosComponent
                vehiculosData={vehiculosData}
                setVehiculosSelected={setVehiculosSelected}
              />
              {vehiculosSelected !== null && (
                <CotizacionVehiculosComponent vehiculo={vehiculosSelected} />
              )}
            </>
          )}
        </div>
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default MultiCotizacionPage;